import { StackScreen } from '@banhala/ui-kit';
import { useState } from 'react';
import { CartIcon, SearchIcon } from 'shared/src/component';
import { AnalyticsScreen } from 'shared/src/context';
import { LikeContents } from './components';
import { LIKE_TABS } from './constants';

export const LikeScreen = () => {
  const { item_list, selected_id } = LIKE_TABS;
  const [index, setIndex] = useState(() =>
    item_list.findIndex(item => item.id === selected_id),
  );
  const screenName = item_list[index]?.screen_name ?? '';

  return (
    <AnalyticsScreen screen={screenName} hostsModals={false}>
      <StackScreen
        title={'찜'}
        hideBackButton={true}
        rightIcons={[<SearchIcon />, <CartIcon />]}
      >
        <LikeContents
          tabs={item_list}
          index={index}
          onIndexChange={setIndex}
        />
      </StackScreen>
    </AnalyticsScreen>
  );
};
